import { Component, AfterViewInit, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialogRef } from '@angular/material/dialog';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { ModalpopService } from '../modalpop.service';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
@Component({
  selector: 'app-admission-details',
  templateUrl: './admission-details.component.html',
  styleUrls: ['./admission-details.component.scss']
})
export class AdmissionDetailsComponent implements OnInit, AfterViewInit {
  @Output() next = new EventEmitter<void>();
  @Output() prev = new EventEmitter<void>();
  @Output() first = new EventEmitter<void>();
  @Input() tabName: string = '';
  dialogRef: MatDialogRef<any>;
  courseList: any;
  filteredCourseList: any;
  facultyList: any;
  filteredFacultyList: any;
  courseStreamList: any;
  examList: any;
  filteredExamList: any;
  filteredStreamList: any;
  stucourseClgMapList: any;
  filteredstucourseClgMapListList: any;
  disabled = true;
  showtxt = false;
  notOpen = false;
  AdmClosed = false;
  subList: any;
  filteredSubList: any;
  filteredstudyModeList: any;
  studyModeList: any;
  sTypeList: any;
  filteredsTypeList: any;
  CourseCode: any;
  savebtn: boolean;
  updateBtn: boolean;
  StrCode: any;
  InstId: any;
  Subs = false;
  OptSub = false;
  noCheckboxSelected = false;
  SubjectName: any[] = [];
  AllSub: any[] = [];
  Sub: any[] = [];
  optData: any;
  optDataForGroup: any;
  checkedValues: any;
  code: any;
  msg: any;
  SubjectData = [];
  parsedData: any;
  FromDate: Date;
  ToDate: Date;
  Course: any;
  College: any;
  tabs : string;
  displayName : any;
  constructor(private fb: FormBuilder, private modalPopupService: ModalpopService,
    public umsService: UmsService, private spinner: NgxSpinnerService) { }
  admissionDetailsForm: FormGroup;
  submitButton = true;
  updateButton = false;
  BranchId = 0;
  admissionDetailsFormArray;
  selectedValues: any[] = [];
  newSelectedValues = [];
  Subjects: any[] = [];
  GroupData: any[] = [];
  selectedCheckboxes: any = [];
  selectedOptions: any = [];
  validationErrors: { [key: string]: string } = {};
  MinMax = false;
  StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
  session = sessionStorage.getItem('session');
  studentId = sessionStorage.getItem('StudentRGID');
  sessionList: any[];
  SessionFilterList: any[];
  BranchShow =false
  AdmDetailsShow = false;
  ngOnInit(): void {
    this.Subs = false;
    this.OptSub = false;
    this.noCheckboxSelected = false;
    this.MinMax = false;
    this.notOpen = false;
    this.AdmClosed = false;
    this.submitButton = true;
    this.updateButton = false;
    this.AdmDetailsShow = false;
    this.validationErrors = {};
    this.StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
    this.session = sessionStorage.getItem('session');
    this.disabled = false;
    this.BranchId = 0;
    this.admissionDetailsForm = this.fb.group({
      StuId: new FormControl(this.StudentPersonalId),
      SubChecked: new FormControl('')
    });

    this.getFacultyData();
    this.getScrutiny();
    this.fetchStudyMode();
    this.fetchStudentType();
    this.getScretData();
    this.getSessionData()
    this.getApplyData();
    this.prepopulation();
  }
  ngAfterViewInit(): void {
    this.prepopulation();
  }

  getApplyData(){
    this.spinner.show();
    let payload = {}
    this.Course = ''
    this.College = ''
    payload['LoginId'] = sessionStorage.getItem('loginId');
    this.umsService.getApplyData(payload).subscribe((res) => {
      if(res.status){
        this.spinner.hide();
       this.Course = res.data[0]['Course'];
       this.College = res.data[0]['College'];
      }
      else{
        this.spinner.hide();
        this.Course = ''
        this.College = ''
      }
    }, (ERROR: HttpErrorResponse) => {
      this.Course = ''
      this.College = ''
      this.spinner.hide();
    });
  }

  getCollege(){
    this.spinner.show();
    const payload3 = {};
    payload3['CoCode'] = this.Course;
    this.filteredstucourseClgMapListList = [];
    this.umsService.fetchstucourseClgMap(payload3).subscribe(res => {
      if(res.status){
        this.spinner.hide()
        this.stucourseClgMapList = res.data;
        this.filteredstucourseClgMapListList = this.stucourseClgMapList.slice();
        if(this.College != ''){
          this.admissionDetailsForm.controls['StuCgId'].setValue(this.College);
        }
        
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  onCheckbox(event: any, checkbox: any): void {
    this.noCheckboxSelected = false;
    if (typeof this.selectedCheckboxes[0] === "object") {
      this.selectedCheckboxes = []
    }
    if (typeof checkbox === "string") {
      const index = this.selectedCheckboxes.indexOf(checkbox);
      const isChecked = event.checked;

      if (isChecked && index === -1) {
        this.selectedCheckboxes.push(checkbox);
      } else if (!isChecked && index !== -1) {
        this.selectedCheckboxes.splice(index, 1);
      }
    }
    else if (typeof checkbox[0] === "object") {
      checkbox.forEach(element => {
        if (typeof element === "string") {
          const index = this.selectedCheckboxes.indexOf(element);
          const isChecked = event.checked;
          if (isChecked && index === -1) {
            this.selectedCheckboxes.push(element);
          } else if (!isChecked && index !== -1) {
            this.selectedCheckboxes.splice(index, 1);
          }
        }
      });
    }

  }

  checkMatchingOpCode(group: any) {
    return this.optData.some(item => item.OpCode === group.EsOpCode);
  }

  onCheckboxChanged(event: any, checkbox: any): void {
    // this added for update button enable and disable
    const payload = {};
    payload['StudentId'] = sessionStorage.getItem('StudentPersonalId');
    this.umsService.fetchScrutinyLock(payload).subscribe(res => {
      this.tabs = res.data[0].Tabs;
       if (res.data.length == 0 || res.data[0]['Status'] == 'DCERR') {
        this.spinner.hide();
        if(res.data[0].Tabs.includes('Admission Details')){
          this.disabled = false;
        }else{
          this.disabled = true;
        }
      }
      else {
        this.spinner.hide();
        this.disabled = true;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
    this.noCheckboxSelected = false;
    const index = this.selectedCheckboxes.indexOf(checkbox);
    const isChecked = event.checked;
    if (isChecked && index === -1) {
      this.selectedCheckboxes.push(checkbox);
    } else if (!isChecked && index !== -1) {
      this.selectedCheckboxes.splice(index, 1);
    }
    this.validateCheckboxesForItem();
  }

  validateCheckboxesForItem(): void {

    for (const item of this.optData) {
      const selectedForItem = this.selectedCheckboxes.filter(
        (checkbox) => checkbox.EsOpCode === item.OpCode
      );
      this.validateCheckboxes(item, selectedForItem);
    }
  }

  validateCheckboxes(item: any, selectedCheckboxes1: any[]): void {

    const totalSelected = selectedCheckboxes1.length;
    const opMin = item.OpMin;
    const opMax = item.OpMax;
    const opCode = item.OpCode
    if (totalSelected < opMin || totalSelected > opMax) {
      this.validationErrors[item.OpCode] = `For OptionCode ${opCode} Select Minimum ${opMin} or Maximum ${opMax}`;
      this.disabled = true;
    } else {
      delete this.validationErrors[item.OpCode];
      this.noCheckboxSelected = false;
      if (this.showtxt == false && this.notOpen == false && this.AdmClosed == false) {
        this.disabled = false;
      }
      else {
        this.disabled = true
      }

    }
    this.getValidationErrorsKeys()
  }

  getValidationErrorsKeys(): string[] {
    return Object.keys(this.validationErrors);
  }

  getScretData() {
    this.spinner.show()
    this.umsService.getSecretData().subscribe((res) => {
      if(res.status){
        this.spinner.hide();
        this.InstId = res.projectPharam['ClubPartTrans'];
      }
      else{
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  onSelectionChange(event: any) {
  
    this.newSelectedValues = event.value
  }

  getScrutiny() {
    this.spinner.show();
    const payload = {};
    payload['StudentId'] = sessionStorage.getItem('StudentPersonalId');
    this.umsService.fetchScrutinyLock(payload).subscribe(res => {
      this.tabs = res.data[0].Tabs;
       if (res.data.length == 0 || res.data[0]['Status'] == 'DCERR') {
        this.spinner.hide();
        if(res.data[0].Tabs.includes('Admission Details')){
          this.disabled = false;
        }else{
          this.disabled = true;
        }
      }
      else {
        this.spinner.hide();
        this.disabled = true;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }


  prepopulation() {
    this.spinner.show()
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    this.umsService.fetchAddmissionDetails(payload).subscribe((res) => {
      if (res.status) {

        res.data[0].StuBrId = parseInt(res.data[0].StuBrId);
        res.data[0].StuEmId = parseInt(res.data[0].StuEmId);
        res.data[0].StuSubjectRg = res.data[0].StuSubjectRg.split(",")
        if (res.data.length > 0) {
          sessionStorage.setItem("StudentPersonalId", res.data[0].StuId);
          sessionStorage.setItem("StuAcadId", res.data[0].StuAcadId);
          this.umsService.disable7 = false;
          
          this.getExamStreamData(res.data[0].StuCoId);
          this.selectedValues = res.data[0].StuSubjectRg;
          const dataArray = res.data[0].StuSubjectRgCopy.split(',');
          
          
          dataArray.forEach(item =>{   
          const splitValues = item.split('-');   
          const Id= splitValues.pop(); 
          // Extract the last element as Id
          const Code = splitValues.join('-'); 
          // remaining Code
          const  obj = {Code,Id};  
           this.newSelectedValues.push(obj); 
          });
          this.submitButton = false;
          this.updateButton = true;
          
          this.prepopulatedatapage(res);

        } else {
          this.loadsettingspage();
        }
      } else {
        this.spinner.hide();
        this.loadsettingspage();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }


  prepopulation2() {
    this.spinner.show()
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    this.umsService.fetchAddmissionDetails(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        if (res.data.length > 0) {
            this.umsService.disable7 = false;
        } else {
           this.umsService.disable5 = true;
        }
      } else {
        this.spinner.hide();
        this.loadsettingspage();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  shouldCheckItemForGroup(child): boolean {
    return this.selectedCheckboxes.some(item => item.EsId === child.EsId);
  }

  shouldCheckItemForSubject(item1): boolean {
    return this.selectedCheckboxes.some(item => item.EsId === item1.EsId);
    
  }

  prepopulatedatapage(e) {
    this.spinner.show()
    let payload = {};
    payload['FormPage'] = 'AdmDetails';
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      this.spinner.hide()
      ress.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.admissionDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], Validators.required));

            } else {
              this.admissionDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], [Validators.required, Validators.pattern(element.FormPattern)]));
            }
          }
          else {
            if (element.FormPattern == '') {
              this.admissionDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
            } else {
              this.admissionDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
            }
          }
        }
        else {
          this.admissionDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        }
      });
      this.admissionDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      this.AdmDetailsShow = true;
      this.getCourseData(this.Course);
      this.getCollege();
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });

  }

  NewCoSch(CoCode, CShSnNo, StuId, StuCgId) {
    this.spinner.show();
    const payload = {};
    payload['CoCode'] = CoCode;
    payload['CShStatus'] = '';
    payload['LoginId'] = 0;
    payload['CShSnNo'] = CShSnNo;
    this.umsService.NewCoSch(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.NewSearchCoSch(res.data[0]['CShId'], CoCode, CShSnNo, StuId, StuCgId)
      }
      else{
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  NewSearchCoSch(ShId, CoCode, CShSnNo, StuId, StuCgId) {
    this.spinner.show();
    const payload = {};
    payload['CEcShId'] = ShId;
    this.umsService.NewSearchCoSch(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.personalDetails(res.data[0]['CEcId'], CoCode, CShSnNo, StuId, StuCgId)
      }
      else{
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  personalDetails(ECID, CoCode, CShSnNo, StuId, StuCgId) {
    this.spinner.show();
    let payload = {};
    payload['StuRgNo'] = this.studentId
    this.umsService.fetchPersonalDetails(payload).subscribe((res) => {
      if(res.status){
        this.spinner.hide();
        let data = res.data[0]
        this.RegnForm(ECID, CoCode, CShSnNo, StuId, StuCgId, data.StuFirstNameEng, data.StuRgNo, data.StuMidNameEng, data.StuBirthDate, data.EmailID)
      }
      else{
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  RegnForm(EcId, CoCode, CShSnNo, StuId, StuCgId, Name, RgNo, Father, BirthDate, EMail) {
    this.spinner.show();
    const payload = {};
    payload['CSExBr'] = '';
    payload['Code'] = '';
    payload['Colg'] = '';
    payload['valid'] = 'Y';
    payload['changed'] = '';
    payload['CgCodee'] = '';
    payload['Batch'] = '';
    payload['Name'] = Name;
    payload['RgNo'] = RgNo;
    payload['FormNo'] = '';
    payload['CgCode'] = StuCgId;
    payload['Chng'] = 'Y';
    payload['Valid'] = '';
    payload['Father'] = Father;
    payload['Mother'] = '';
    payload['BirthDate'] = BirthDate;
    payload['Sex'] = 'M';
    payload['Cate'] = 'R';
    payload['Caste'] = 'OBC';
    payload['EMail'] = EMail;
    payload['Medium'] = 'E';
    payload['Nation'] = '1';
    payload['Mobile'] = '';
    payload['Addr1'] = '';
    payload['Addr2'] = '';
    payload['Addr3'] = '';
    payload['Addr1P'] = '';
    payload['Addr2P'] = '';
    payload['Addr3P'] = '';
    payload['Pin'] = '';
    payload['PinP'] = '';
    payload['Place'] = '';
    payload['StrCode'] = this.StrCode ? this.StrCode : 0;
    payload['PlaceP'] = '';
    payload['ExSub'] = '';
    payload['Sub'] = '';
    payload['EcId'] = EcId;
    payload['CoCode'] = CoCode;
    payload['SnNo'] = CShSnNo;
    payload['EmSrNoF'] = '';
    payload['msg'] = '';
    payload['EmSkip'] = '';
    payload['StuId'] = StuId;
    this.umsService.RegnTemp(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.Validate(EcId, RgNo, CShSnNo, StuCgId, CoCode);

      } else {
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  Validate(EcId, RgNo, CShSnNo, CgCode, CoCode) {
    this.spinner.show();
    const payload = {};
    payload['Batch'] = '';
    payload['EcId'] = EcId;
    payload['Inst'] = this.InstId;
    this.umsService.ValidateTemp(payload).subscribe((res) => {
      if(res.status){
        this.spinner.hide();
        this.checkTemp(RgNo, CShSnNo, CgCode, CoCode);
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  checkTemp(RgNo, CShSnNo, CgCode, CoCode) {
    this.spinner.show();
    const payload = {};
    payload['RgNo'] = RgNo;
    payload['SnNo'] = CShSnNo;
    payload['CgCode'] = CgCode;
    payload['CoCode'] = CoCode;
    this.umsService.checkTemp(payload).subscribe((res) => {
      
      if (res.data[0]['Mesg'] != '') {
        this.spinner.hide();
        let data = {};
        data['message'] = res.data[0]['Mesg'];
        data['title'] = 'Information';
        data['icon'] = 'fas fa-check';
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(
          AlertboxComponent,
          data
        );

      }
      else if (res.data[0]['Mesg'] == '') {
        this.spinner.hide();
        this.next.emit();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });

  }



  loadsettingspage() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'AdmDetails';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide();
      res.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.admissionDetailsForm.addControl(
                element.FormControlName,
                new FormControl('', Validators.required)
              );
            } else {
              this.admissionDetailsForm.addControl(
                element.FormControlName,
                new FormControl('', [Validators.required, Validators.pattern(element.FormPattern)])
              );
            }
          } else {
            if (element.FormPattern == '') {
              this.admissionDetailsForm.addControl(element.FormControlName, new FormControl(''));
            } else {
              this.admissionDetailsForm.addControl(element.FormControlName, new FormControl('', [Validators.pattern(element.FormPattern)]));
            }

          }
        }
      });
      this.admissionDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      this.AdmDetailsShow = true;
      this.getCourseData(this.Course);
      this.getCollege();
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }
  UpdateQualificationDetails() {
    for (let i = this.selectedCheckboxes.length - 1; i >= 0; i--) {
      if (this.selectedCheckboxes[i].EsType === 'P') {
        this.selectedCheckboxes.splice(i, 1);
      }
    }
    if (this.selectedCheckboxes.length == 0) {
      this.noCheckboxSelected = true
      return
    }
    else {
      this.disabled = false;
      if (typeof this.selectedCheckboxes[0] === "string") {
        this.update()
      } else if (typeof this.selectedCheckboxes[0] == "object") {
        this.validateCheckboxesForItem();
        const isEmpty = Object.keys(this.validationErrors).length === 0;

        if (!isEmpty) {
          this.disabled = true;

        } else if (isEmpty) {
          this.disabled = false;
          this.update();

        }

      }

    }


  }
  UpdScrtDetails(){
    this.spinner.show();
    let payload = {};
    payload['StuId'] = parseInt(this.StudentPersonalId)
    payload['SessionId'] = parseInt(sessionStorage.getItem('session'));
    payload['CgCode'] = this.College
    payload['CoCode'] = this.Course
    this.umsService.UpdScrtDetails(payload).subscribe((res) => {
      if(res.status){
        this.spinner.hide();
        this.first.emit();
        location.reload();
      }
      else{
        this.spinner.hide();
        
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }
  // getTabName(e){
  //   this.displayName = e;
  // }
  getTabDisplayName(): string {
    return `Current Tab: ${this.tabName}`;
  }
  update() {
    if (this.admissionDetailsForm.invalid) {
         this.SubmitFormarkAsTouched();
    } else {
      if(this.tabs){
        const lastTab: string = this.tabs.split(', ').pop() || '';
        if( this.tabName == lastTab){
            const data = {};
            data['message'] = 'Are You Sure You Have Updated ' + this.tabs + ' Tabs. Do You Want To Proceed?';
            data['title'] = 'Alert';
            data['icon'] = 'fa fa-question';
            this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
            this.dialogRef.afterClosed().subscribe(result => {
              if (result === 'yes') {
                this.UpdScrtDetails();
                this.UpdateScrutiny();
              } else {
                this.dialogRef.close();
                  
              }
          });
          }
          else{
            this.UpdateScrutiny();
          }
        }
        else{
          this.UpdateScrutiny();
        }
    }
  }
  UpdateScrutiny(){
    let StuAcadId = sessionStorage.getItem('StuAcadId');
    this.submitButton = false;
    this.updateButton = true;
    this.spinner.show();
    let payload = this.admissionDetailsForm.value;
    payload.StuId = parseInt(payload.StuId);
    payload.StuCoLvl = parseInt(payload.StuCoLvl);
    payload.StuEmId = parseInt(payload.StuEmId);
    if (this.selectedCheckboxes.length == 0) {
      payload.StuSubjectRg = [''];
    }

    payload.SessionId = this.session;
    if (typeof this.selectedCheckboxes[0] === "string") {
      const result = [this.selectedCheckboxes.join(',')];
      payload.StuSubjectRg = result;
    } else if (typeof this.selectedCheckboxes[0] == "object") {
      let selectedSubjects = [...this.selectedCheckboxes];
      for (let i = selectedSubjects.length - 1; i >= 0; i--) {
        if (selectedSubjects[i].EsType === 'G') {
          selectedSubjects.splice(i, 1);
        }
      }
      let esCodeArray = selectedSubjects.map(item => item.EsCode);
      const result = [esCodeArray.join(',')];
      payload.StuSubjectRg = result;
    }
    let combinedValues = []; 
    this.selectedCheckboxes.forEach(item => {
      if (item.EsType === 'G') {
        combinedValues.push(`${item.EsCode}-${item.EsId}`);
      } else if (item.EsType === 'S') {
        combinedValues.push(`${item.EsCode}-${item.EsParent}`);
      }
    });

    const result2 = [combinedValues.join(',')];
    payload['StuAcadId'] = parseInt(StuAcadId);
    payload['StuSubjectRgCopy'] = result2
    payload['LoginId'] = parseInt(sessionStorage.getItem('StudentRGID'));
    this.umsService.updateAddmissionDetails(payload).subscribe(res => {
      if(res.status){
      sessionStorage.setItem("StuEmId", payload.StuEmId);
      sessionStorage.setItem("StuCoId", payload.StuCoId);
      sessionStorage.setItem("StuCgId", payload.StuCgId);
      this.updateSubjectSelection();
      this.spinner.hide();
      let data = {}
      data['message'] = res.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      this.next.emit();
      this.dialogRef.afterClosed().subscribe((result) => {
        
      });
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    }
    );
  }

  getFacultyData() {
    this.spinner.show();
    const payload = {};
    this.Subjects = [];
    this.GroupData = [];
    this.umsService.fetchFaculty(payload).subscribe(res => {
      if(res.status){
        this.spinner.hide();
        this.Subjects = [];
        this.GroupData = [];
        this.facultyList = res.data;
        this.filteredFacultyList = this.facultyList.slice();
      }
      else{
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  getCourseData(id) {
    this.spinner.show()
    const payload = {};
    payload['CoCode'] = this.Course;
     this.filteredCourseList = [];
    this.filteredStreamList = [];
    this.StrCode = '';
    this.filteredExamList = [];
    this.filteredSubList = [];
    this.selectedValues = [];
    this.Subjects = [];
    this.GroupData = [];
    this.SubjectName = [];
    this.AllSub = [];
    this.Sub = [];
    this.filteredstucourseClgMapListList = [];
    this.umsService.fetchCourseType(payload).subscribe(res => {
      if(res.status){
        this.Subjects = [];
      this.GroupData = [];
      this.spinner.hide()
      this.courseList = res.data;
      this.filteredCourseList = this.courseList.slice();
      if(this.Course != ''){
        this.admissionDetailsForm.controls['StuFacId'].setValue(res.data[0]['CoFcCode']);
        this.admissionDetailsForm.controls['StuCoId'].setValue(this.Course);
      }
      
      }
      else{
        this.spinner.hide();
      }
      this.AdmDetailsShow = true;
      setTimeout(() => {
        this.spinner.hide();
      }, 2500); // 2000 milliseconds = 2 seconds
      
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }



  getExamStreamData(id) {
    this.spinner.show()
    this.filteredStreamList = [];
    this.StrCode = '';
    this.BranchId = 0;
    this.filteredExamList = [];
    this.filteredSubList = [];
    this.selectedValues = [];
  
    this.Subjects = [];
    this.GroupData = []
    this.SubjectName = [];
    this.AllSub = [];
    this.Sub = [];
    this.filteredstucourseClgMapListList = [];
    this.CourseCode = id;
    sessionStorage.setItem("CoCodeee", this.CourseCode)
    const payload = {};
    payload['CoCode'] = id;
    payload['EmId'] = 0;
    this.umsService.fetchCourseBranch(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        this.courseStreamList = res.data;
        this.filteredStreamList = this.courseStreamList.slice();
      }
      else {
        this.spinner.hide()
        this.BranchId = 0;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    }
    );

    const payload2 = {};
    payload2['EmCoCode'] = id;
    payload2['EmId'] = 0;
    this.Subjects = [];
    this.GroupData = []
    this.umsService.fetchExam(payload2).subscribe(res => {
      if(res.status){
        this.spinner.hide()
        this.Subjects = [];
        this.GroupData = []
        this.examList = res.data;
        this.filteredExamList = this.examList.slice();
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
    const payload3 = {};
    payload3['CoCode'] = id;
    this.filteredstucourseClgMapListList = [];
    this.umsService.fetchstucourseClgMap(payload3).subscribe(res => {
      if(res.status){
        this.spinner.hide()
        this.stucourseClgMapList = res.data;
        this.filteredstucourseClgMapListList = this.stucourseClgMapList.slice();
        if(this.College != ''){
          this.admissionDetailsForm.controls['StuCgId'].setValue(this.College);
        }
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  getExam(id) {
    this.spinner.show();
    this.Subjects = [];
    this.GroupData = []
    this.optData = '';
    const payload2 = {};
    payload2['EmCoCode'] = id;
    payload2['EmId'] = 0;
    this.umsService.fetchExam(payload2).subscribe(res => {
      if(res.status){
        this.spinner.hide()
        this.Subjects = [];
        this.GroupData = []
        this.examList = res.data;
        this.filteredExamList = this.examList.slice();
      }
      else{
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });

  }

  getSubData(id) {
  
    if(id.EmStreams == 'N'){
    this.BranchShow =false;
    this.spinner.show()
    const payload = {};
    payload['EsEmId'] = id.EmId;
    payload['EsStrId'] = this.admissionDetailsForm.value.StuBrId;
    this.umsService.fetchSubs(payload).subscribe(async res => {
      if(res.status){
        this.spinner.hide()
      this.Subjects = [];
      this.GroupData = []
      this.selectedCheckboxes = [];
      this.SubjectName = [];
      this.AllSub = [];
      this.Sub = []
      await this.getExamSubMapFetch(this.admissionDetailsForm.value['StuEmId'], this.BranchId);
      this.subList = res.data;
      this.filteredSubList = this.subList.slice();
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
    }else{
      this.BranchShow =true;
    }
   
  }

  getSubDatawithBranch(id) {
    // if(id.EmStreams == 'N'){
    // this.BranchShow =false;
    // }else{
    //   this.BranchShow =true;
    // }
    this.spinner.show()
    let data = this.admissionDetailsForm.value
    const payload = {};
    payload['EsEmId'] = this.admissionDetailsForm.value.StuEmId;
    payload['EsStrId'] = id.StrId;
    this.umsService.fetchSubs(payload).subscribe(async res => {
      if(res.status){
        this.spinner.hide()
      this.Subjects = [];
      this.GroupData = []
      this.selectedCheckboxes = [];
      this.SubjectName = [];
      this.AllSub = [];
      this.Sub = []
      await this.getExamSubMapFetch(this.admissionDetailsForm.value['StuEmId'], this.BranchId);
      this.subList = res.data;
      this.filteredSubList = this.subList.slice();
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }
  getExamSubMapFetch(EmId, BranchId) {
    this.Subjects = [];
    this.GroupData = [];
    this.Subs = false;
    this.OptSub = false;
    this.spinner.show();
    const payload = {};
    payload['EsEmId'] = EmId;
    payload['EsStrId'] = this.admissionDetailsForm.value.StuBrId;
    this.umsService.getExamSubMapFetch(payload).subscribe(async res => {
      if(res.status){
        this.spinner.hide();
        this.SubjectData = res.data.children;
        this.SubjectData.forEach(element => {
          if (element.EsType == 'S') {
            this.Subs = true;
            if (this.Subjects.indexOf(element.EsCode) === -1) {
              this.Subjects.push(element.EsCode);
              this.SubjectName.push(element.EsName);
              this.Sub.push(element.EsOpCode)
              this.AllSub.push(element)
              if (element.EsOpCode !== ' ') {
                const DupOpt = this.selectedOptions.some((item: any) => item === element.EsOpCode);
                if (!DupOpt) {
                  this.selectedOptions.push(element.EsOpCode);
                }
              }
            }
            if (element.EsOpCode == " " && element.EsType == 'S') {
              const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element.EsId);
              if (!isDuplicate) {
                this.selectedCheckboxes.push(element);
              }
            }
            this.newSelectedValues.forEach(element2 => {
              if (element2.Code == element.EsCode && element2.Id == element.EsParent) {
                const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element.EsId);
                if (!isDuplicate) {
                  this.selectedCheckboxes.push(element);
                }
  
              }
            })
          }
          else if (element.EsType == 'G') {
            this.OptSub = true;
            if (element.EsOpCode !== ' ') {
  
              const DupOpt = this.selectedOptions.some((item: any) => item === element.EsOpCode);
              if (!DupOpt) {
                this.selectedOptions.push(element.EsOpCode);
              }
            }
            const isDuplicate = this.GroupData.some((item: any) => item.EsId === element.EsId);
            if (!isDuplicate) {
              this.GroupData.push(element);
            }
            element.children.forEach(element1 => {
              if (element1.EsOpCode !== ' ') {
                const DupOpt = this.selectedOptions.some((item: any) => item === element1.EsOpCode);
                if (!DupOpt) {
                  this.selectedOptions.push(element1.EsOpCode);
                }
              }
  
              if (element1.EsOpCode == " ") {
                const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element1.EsId);
                if (!isDuplicate) {
                  this.selectedCheckboxes.push(element1);
                }
              }
  
              this.newSelectedValues.forEach(element2 => {
  
                if (element2.Code == element1.EsCode && element2.Id == element1.EsParent) {
                  const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element1.EsId);
                  if (!isDuplicate) {
                    this.selectedCheckboxes.push(element1);
                  }
  
                }
  
              })
            });
  
            this.newSelectedValues.forEach(element2 => {
  
              if (element2.Code == element.EsCode && element2.Id == element.EsId) {
                const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element.EsId);
                if (!isDuplicate) {
                  this.selectedCheckboxes.push(element);
                }
  
              }
  
            })
            for (const value of this.newSelectedValues) {
              element.children.forEach(element2 => {
                if (element2.EsOpCode !== ' ') {
                  const DupOpt = this.selectedOptions.some((item: any) => item === element2.EsOpCode);
                  if (!DupOpt) {
                    this.selectedOptions.push(element2.EsOpCode);
                  }
                }
              });
            }
  
          } else {
          }
        });
        await this.getOptionData(EmId, BranchId);
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });


  }

  getOptDataForGroup(group: any) {
    return this.optData.find(item => item.OpCode === group.EsOpCode);
  }

  minmaxsubject(q) {
    q.forEach(element => {
      if (element.EsOpCode != ' ') {
        let EsOpCode = element.EsOpCode
        this.optData.forEach(element1 => {
          if (element1.OpCode === EsOpCode) {
            let OptionData = element1
            this.code = OptionData.OpCode
            this.msg = `Minimum = ` + OptionData.OpMin + ` & Maximum = ` + OptionData.OpMax
          }
        });
      }
    });
    return this.msg
  }



  getOptionData(EmId, BranchId) {
    this.optData = '';
    this.spinner.show();
    const payload = {};
    payload['OpEmId'] = EmId;
    payload['OpStrId'] = this.admissionDetailsForm.value.StuBrId;
    this.umsService.getOption(payload).subscribe((res) => {
      if (res.status == true) {
        this.spinner.hide();
        const filteredArray = res.data.filter(item => this.selectedOptions.includes(item.OpCode));
        
        this.optData = filteredArray;
        this.MinMax = true;
      }
      else {
        this.spinner.hide();
        this.MinMax = false;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  getClgMapp(id) {
    this.spinner.show();
    const payload3 = {};
    payload3['CoCode'] = id;
    this.umsService.fetchstucourseClgMap(payload3).subscribe(res => {
      if(res.status){
        this.spinner.hide();
      this.stucourseClgMapList = res.data;
      this.filteredstucourseClgMapListList = this.stucourseClgMapList.slice();
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  getBrId(id, code) {
    this.BranchId = id;
    this.StrCode = code;
  }

  SubmitFormarkAsTouched() {
    this.spinner.show()
    let payload = {};
    payload['FormPage'] = 'AdmDetails';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide()
      res.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            const control = this.admissionDetailsForm.get(element.FormControlName);
            if (control) {
              control.markAsTouched();
            }
          }
        }
      });
      this.admissionDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }


  submitAddmissionDetails() {

    if (this.admissionDetailsForm.invalid) {
        this.SubmitFormarkAsTouched();
    } else {
      this.submit()
    }

  }

  submit() {
    for (let i = this.selectedCheckboxes.length - 1; i >= 0; i--) {
      if (this.selectedCheckboxes[i].EsType === 'P') {
        this.selectedCheckboxes.splice(i, 1);
      }
    }

    if (this.selectedCheckboxes.length == 0) {
      this.validateCheckboxesForItem();
      this.noCheckboxSelected = true
      return
    }

    else {

      this.disabled = false;
      if (typeof this.selectedCheckboxes[0] === "string") {
        this.submitFinal()
      } else if (typeof this.selectedCheckboxes[0] == "object") {
        this.validateCheckboxesForItem();
        const isEmpty = Object.keys(this.validationErrors).length === 0;

        if (!isEmpty) {
          this.disabled = true;
         

        } else if (isEmpty) {
          this.disabled = false;
          this.submitFinal();

        }

      }
    }
  }

  submitFinal() {
    let combinedValues = [];
    this.submitButton = true;
    this.updateButton = false;
    this.spinner.show();
    let payload = this.admissionDetailsForm.value;
    payload.StuId = parseInt(payload.StuId);
    payload.StuCoLvl = parseInt(payload.StuCoLvl);
    payload.StuEmId = parseInt(payload.StuEmId);
    payload.SessionId = this.session;
    if (typeof this.selectedCheckboxes[0] === "string") {
      const result = [this.selectedCheckboxes.join(',')];
      payload.StuSubjectRg = result;
    } else if (typeof this.selectedCheckboxes[0] == "object") {
      let selectedSubjects = [...this.selectedCheckboxes];
      for (let i = selectedSubjects.length - 1; i >= 0; i--) {
        if (selectedSubjects[i].EsType === 'G') {
          selectedSubjects.splice(i, 1);
        }
      }
      let esCodeArray = selectedSubjects.map(item => item.EsCode);
      const result = [esCodeArray.join(',')];
      payload.StuSubjectRg = result;
    }
    this.selectedCheckboxes.forEach(item => {
      if (item.EsType === 'G') {
        // For EsType G, storing EsCode-EsId
        combinedValues.push(`${item.EsCode}-${item.EsId}`);
      } else if (item.EsType === 'S') {
        // For EsType S, storing EsCode-EsParent
        combinedValues.push(`${item.EsCode}-${item.EsParent}`);
      }
    });

    const result2 = [combinedValues.join(',')];
    payload['StuSubjectRgCopy'] = result2
    this.spinner.hide();
    payload['LoginId'] = parseInt(sessionStorage.getItem('StudentRGID'));
    this.umsService.addAddmissionDetails(payload).subscribe(res => {
      sessionStorage.setItem("StuEmId", payload.StuEmId);
      sessionStorage.setItem("StuCoId", payload.StuCoId);
      sessionStorage.setItem("StuCgId", payload.StuCgId);
      this.submitSubjectSelect()
      this.spinner.hide();
      let data = {}
      data['message'] = res.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
     
      this.dialogRef.afterClosed().subscribe((result) => {
       
      });

      this.next.emit();

    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
     this.dialogRef.afterClosed().subscribe((result) => {
      });
    }
    );
  }
  back() {
    this.prev.emit();
  }


  fetchStudyMode() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'AMODE';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.studyModeList = res.data;
        this.filteredstudyModeList = this.studyModeList.slice();
      } else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }


  fetchStudentType() {
    this.spinner.show()
    const payload = {};
    payload['CdType'] = 'STYPE';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.sTypeList = res.data;
        this.filteredsTypeList = this.sTypeList.slice();
      } else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }



  scrutenylevelCheck(item) {
    this.spinner.show();
    let colgCode = item.CgCode;
    let code = sessionStorage.getItem("CoCodeee")
    const payload = {};
    payload['CoCode'] = code;
    payload['CgCode'] = colgCode;
    payload['SessionId'] = this.session;

    this.umsService.getAssignLevel(payload).subscribe((res) => {
      if (res.data.length < 1) {
      
        this.spinner.hide();
        let data = {}
        data['message'] = "For the selected college and course admissions are not open"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.disabled = false;
          this.showtxt = false;
        });
      } else {
        this.spinner.hide();
           this.disabled = false;
        this.showtxt = false;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  cutoff(code) {
    this.spinner.show()
    this.notOpen = false;
    this.AdmClosed = false;
    this.showtxt = false;
    this.disabled = false;
    let data = this.admissionDetailsForm.value
    const payload = {};
    payload['SessionID'] = parseInt(sessionStorage.getItem('session'));
    payload['CoCgCgCode'] = code;
    payload['CoCgCoCode'] = data.StuCoId;
    payload['InCode'] = "ADM";
    payload['EmId'] = '';
    this.umsService.findSessionCutOff(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        this.showtxt = false;
        const todayDate = new Date();

        for (const element of res.data) {
          const fromdate = new Date(element['CutOffDateFrom']);
          const toDate = new Date(element['CutOffDate']);

          // Set hours, minutes, seconds, and milliseconds to 0 for accurate date comparison
          todayDate.setHours(0, 0, 0, 0);
          fromdate.setHours(0, 0, 0, 0);
          toDate.setHours(0, 0, 0, 0);
          if (todayDate >= fromdate && todayDate <= toDate) {
            this.notOpen = false;
            this.disabled = false
            this.AdmClosed = false;
            break; // Exit the loop if the registration is open
          } else if (todayDate < fromdate) {
            this.FromDate = fromdate;
            this.notOpen = true;
            this.disabled = true;
            this.AdmClosed = false;
            break; // Exit the loop if registration is not open yet
          }
        }

        // If none of the conditions were met, it means today's date is after all the cutoff dates
        if (this.AdmClosed === undefined) {
          this.AdmClosed = true;
          this.disabled = true
        }
      }
      else {
        this.spinner.hide()
        this.showtxt = false;
        this.disabled = false;
      }

    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  getSessionData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getSession(payload).subscribe(res => {
      if(res.status){
        this.spinner.hide();
        this.sessionList = res.data;
        this.SessionFilterList = this.sTypeList.slice();
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.sessionList = [];
      let data = {}
      this.spinner.hide();
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);

    });
  }

  submitSubjectSelect() {
    let combinedValues = [];
    this.submitButton = true;
    this.updateButton = false;
    this.spinner.show();
    let payload2 = {}
    let payload = this.admissionDetailsForm.value;
    payload.StuId = parseInt(sessionStorage.getItem('StudentPersonalId'));
    payload.SubEmId = payload.SubEmId;
    payload.SubSession = parseInt(this.session);
    if (typeof this.selectedCheckboxes[0] === "string") {
      const result = [this.selectedCheckboxes.join(',')];
      payload2['StuSubjectRg'] = result
    } else if (typeof this.selectedCheckboxes[0] == "object") {
      let selectedSubjects = [...this.selectedCheckboxes];
      for (let i = selectedSubjects.length - 1; i >= 0; i--) {
        if (selectedSubjects[i].EsType === 'G') {
          selectedSubjects.splice(i, 1);
        }
      }
      let esCodeArray = selectedSubjects.map(item => item.EsCode);
      const result = [esCodeArray.join(',')];
      payload2['StuSubjectRg'] = result
    }
    this.selectedCheckboxes.forEach(item => {
      if (item.EsType === 'G') {
        // For EsType G, storing EsCode-EsId
        combinedValues.push(`${item.EsCode}-${item.EsId}`);
      } else if (item.EsType === 'S') {
        // For EsType S, storing EsCode-EsParent
        combinedValues.push(`${item.EsCode}-${item.EsParent}`);
      }
    });

    const result2 = [combinedValues.join(',')];
    payload2['StuSubjectRgCopy'] = result2
    payload2['SubSession'] = parseInt(this.session);
    payload2['SubFacId'] = payload.StuFacId
    payload2['SubCoId'] = payload.StuCoId
    payload2['SubBrId'] = payload.StuBrId
    payload2['SubEmId'] = payload.StuEmId
    payload2['SubCgId'] = payload.StuCgId
    payload2['StuId'] = parseInt(sessionStorage.getItem('StudentPersonalId'));
    this.umsService.addSubjectSelectionDetails(payload2).subscribe(res => {
      this.spinner.hide();
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      }
    );
  }

  updateSubjectSelection() { 
    if (this.admissionDetailsForm.invalid) {
     
    } else {
      let SubSecId = sessionStorage.getItem('SubSecId');
      this.spinner.show();
      let payload2 = {}
      let payload = this.admissionDetailsForm.value;
      payload.StuId = parseInt(payload.StuId);
      payload.SubEmId = String(payload.SubEmId);
      payload.SubSession = String(payload.SubSession);
      if (this.selectedCheckboxes.length == 0) {
        payload.StuSubjectRg = [''];
      }

      
      if (typeof this.selectedCheckboxes[0] === "string") {
        const result = [this.selectedCheckboxes.join(',')];
        payload2['StuSubjectRg'] = result
      } else if (typeof this.selectedCheckboxes[0] == "object") {
        let selectedSubjects = [...this.selectedCheckboxes];
        for (let i = selectedSubjects.length - 1; i >= 0; i--) {
          if (selectedSubjects[i].EsType === 'G') {
            selectedSubjects.splice(i, 1);
          }
        }
        let esCodeArray = selectedSubjects.map(item => item.EsCode);
        const result = [esCodeArray.join(',')];
        payload2['StuSubjectRg'] = result
      }
      let combinedValues = []; 
      this.selectedCheckboxes.forEach(item => {
        if (item.EsType === 'G') {
          combinedValues.push(`${item.EsCode}-${item.EsId}`);
        } else if (item.EsType === 'S') {
          combinedValues.push(`${item.EsCode}-${item.EsParent}`);
        }
      });

      const result2 = [combinedValues.join(',')];
      payload2['StuSubjectRgCopy'] = result2
      payload2['SubSecId'] = parseInt(SubSecId);
      payload2['SubSession'] = parseInt(this.session);
      payload2['SubFacId'] = payload.StuFacId
      payload2['SubCoId'] = payload.StuCoId
      payload2['SubBrId'] = payload.StuBrId
      payload2['SubEmId'] = payload.StuEmId
      payload2['SubCgId'] = payload.StuCgId
      payload2['StuId'] = parseInt(sessionStorage.getItem('StudentPersonalId'));
      this.umsService.updateSubjectSelectionDetails(payload2).subscribe(res => {
        if(res.status){
          this.spinner.hide();
        }
        else{
          this.spinner.hide();
       
        }
        
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
      }
      );
    }
  }

  ChangeStudyMode(id){
    let StudyMode = this.studyModeList.filter(data => data.CdCode == id.EmSrNo);
    this.admissionDetailsForm.controls['StuStyMode'].setValue(StudyMode[0]['CdCode'])
  }

}